<template>
  <b-modal v-model="bloqueado" id="modAgregarCita"
           no-close-on-backdrop no-close-on-esc ok-disabled hide-footer>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <template v-slot:modal-header>
      <div>
        <img
            alt="close"
            style="width: 15px; height: 15px;"
            :src="require('../../assets/close.svg')"
        />
        Operación no autorizada
      </div>
    </template>

    <b-row>
      <b-col cols="12" style="text-align: center;">
        <div v-html="msj"></div>
      </b-col>
    </b-row>

    <b-col cols="12" style="text-align: center;">
      <b-button variant="primary" @click="aceptar()">Ok</b-button>
    </b-col>

  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      bloqueado: false,
      msj: ""
    }
  },
  props: {
    idPacienteProp: null,
    urlProp: null
  },
  async mounted() {
    await this.verificarBloqueo();
  },
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    async verificarBloqueo() {
      this.bloqueado = false;
      this.actualizarBloqueo();

      const token = this.$localStorageService.getAccessToken();

      let idPaciente = this.idPacienteProp;
      if (idPaciente == null && this.$route.params != null && this.$route.params.idPaciente != null) {
        idPaciente = this.$route.params.idPaciente;
      }

      if (token == null || idPaciente == null) {
        return;
      }

      let url = this.$route.path;
      if (this.urlProp != null && this.urlProp != "") {
        url = this.urlProp;
      }

      await this.$http.post(this.$api + "lock/check", {"idPaciente": idPaciente, "url": url})
          .then((response) => {
            this.bloqueado = response.data.data;
            this.msj = response.data.message;
          }).finally(() => this.actualizarBloqueo());


    },
    aceptar() {
      this.bloqueado = false;
      this.actualizarBloqueo();
      this.$router.push('/dashboard');
      location.reload();
    },
    actualizarBloqueo() {
      this.$emit("cambiarBloqueo", this.bloqueado)
    }
  },
  // updated() {
  //   this.verificarBloqueo();
  // },
  // watch: {
  //   '$route': {
  //     handler: function () {
  //       this.verificarBloqueo();
  //     },
  //     deep: true,
  //   }
  // }

};
</script>

<style>
li {
  list-style: initial !important;
}
</style>